import styles from "./styles/Display.module.css";

export default function Display({ title = null, children = null }) {
  return (
    <div className={styles.cont}>
      <div className={styles.header}>{title}</div>

      <div className={styles.body}>{children}</div>
    </div>
  );
}
